// extracted by mini-css-extract-plugin
export default {"container":"BetSlipTabs_container--EMn","overflow":"BetSlipTabs_overflow--YEX"};